import { COLORS } from "../../Helper/Colors";

export const styles = {
	control: (provided, state) => {
		return {
			...provided,
			background: "#fff !important",
			borderColor: COLORS.gray,
			":active": {
				...provided[":active"],
				borderColor: COLORS.gray, //"#1CBAA7 !important",
				boxShadow: " 0 0 0 1px #1CBAA7 !important",
			},
			_focus: {
				...provided["_focus"],
				borderColor: COLORS.gray, //"#1CBAA7 !important",
				boxShadow: " 0 0 0 1px #1CBAA7 !important",
			},
		};
	},
	placeholder: (provided, { selectProps }) => ({
		...provided,
		fontSize: "16px",
		color: "#A0AEC0",
	}),
	singleValue: (provided, { selectProps }) => ({
		...provided,
		color: "#000", //"#606060",
	}),
	dropdownIndicator: (provided, { selectProps }) => ({
		...provided,
		color: COLORS.brand,
		background: "transparent",
		"> svg": {
			transition: "all 0.25s ease-in-out",
			transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
		},
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		border: "none !important",
	}),
	crossIcon: (provided) => ({
		...provided,
		color: "#e53e3e",
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 1000,
		boxShadow: COLORS.menuBoxShadow,
	}),
};

export const DropDownStyles = {
	control: (provided, state) => {
		return {
			...provided,
			borderColor: "#fff",
			boxShadow: "none !important",
			":active": {
				...provided[":active"],
				borderColor: "transparent", //"#1CBAA7 !important",
				boxShadow: "none !important",
			},
			":hover": {
				...provided["_focus"],
				borderColor: "transparent", //"#1CBAA7 !important",
				boxShadow: "none !important",
			},
			_focus: {
				...provided["_focus"],
				borderColor: "transparent", //"#1CBAA7 !important",
				boxShadow: "none !important",
			},
		};
	},
	singleValue: (provided, { selectProps }) => ({
		...provided,
		color: "#606060", //"#606060",
	}),
	dropdownIndicator: (provided, { selectProps }) => ({
		...provided,
		color: COLORS.brand,
		background: "transparent",
		"> svg": {
			transition: "all 0.25s ease-in-out",
			transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
		},
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		border: "none !important",
	}),
	crossIcon: (provided) => ({
		...provided,
		color: "#e53e3e",
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 1000,
		boxShadow: COLORS.menuBoxShadow,
	}),
};
